import '@nimbus-ds/styles/dist/index.css';
import ReactDOM from 'react-dom/client';
import App from './app';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(root).render(<App />);
